module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 61
// module chunks = 0